module.exports = __webpack_public_path__ + "img/porcientoretnecion.818d3603.png";